<template>
  <div class="view">
    <div class="content">
      <div class="condition">
        <div class="other_wrap">
          <el-button type="primary" @click="addspecification">新增类目</el-button>
        </div>
      </div>
      <div class="table_wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="name" label="类目名称"></el-table-column>
          <el-table-column label="包含规格">
            <template slot-scope="scope">
              <el-tag
                :key="tag"
                v-for="tag in scope.row.attr_list"
                :disable-transitions="false"
              >{{tag}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="edit(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="del(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pag_wrap">
          <el-pagination
            background
            @current-change="pageIndexChange"
            :page-size="page.pagesize"
            :current-page="page.pageindex"
            layout="total, prev, pager, next"
            :total="page.total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <goodsSpecificationDialog
      :id="id"
      :visible.sync="specificationdialog"
      v-if="specificationdialog"
      @specificationsuccess="specificationsuccess"
    ></goodsSpecificationDialog>
  </div>
</template>
<script>
import goodsSpecificationDialog from "@/components/dialog/goodsSpecificationDialog.vue";
import { pagination } from "@/util/util.js";
import api from "@/api.js";
export default {
  name: "goodsSpecifications",
  components: {
    goodsSpecificationDialog
  },
  data() {
    return {
      tableData: [],
      page: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total
      },
      id: "",
      specificationdialog: false
    };
  },
  created() {
    this.init();
  },
  methods: {
    //初始化请求
    init() {
      this.page.pageindex = 1;
      this.querylist();
    },
    //查询列表
    querylist() {
      let params = {
        page: this.page.pageindex
      };
      this.axios
        .post(api.goods_attr_index, params)
        .then(response => {
          if (response.data.code == 0) {
            this.tableData = response.data.list;
            this.page.total = response.data.all_page;
          } else {
            this.page.total = 0;
          }
        })
        .catch(() => {});
    },
    // 分页
    pageIndexChange(pageindex) {
      this.page.pageindex = pageindex;
      this.querylist();
    },
    // 添加类目
    addspecification() {
      this.id = "";
      this.specificationdialog = true;
    },
    // 添加类目成功回调
    specificationsuccess() {
      this.querylist();
    },
    // 编辑
    edit(id) {
      this.id = id;
      this.specificationdialog = true;
    },
    del(id) {
      this.disableddel(id, 0);
    },
    // 是否可以删除
    disableddel(id, type) {
      let params = {
        id: id,
        type: type
      };
      this.axios
        .post(api.goods_attr_delete_check, params)
        .then(response => {
          if (response.data.code == 0) {
            this.submitdel(id);
          } else {
          }
        })
        .catch(() => {});
    },
    // 删除
    submitdel(id) {
      let params = {
        id: id
      };
      this.axios
        .post(api.goods_attr_delete, params)
        .then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.init();
          } else {
          }
        })
        .catch(() => {});
    }
  }
};
</script>